/* eslint-disable @typescript-eslint/naming-convention */
import { BaseTheme } from "@swiggy-private/dls-web-common/dist/components/themes/precomputed/Base/BaseTheme";
import { ITheme } from "@swiggy-private/dls-web-common/dist/components/types";

export const BlackBaseTheme: ITheme = {
    ...BaseTheme,
    colors: {
        light: {
            ...BaseTheme.colors.light,
            background_Button_Primary: "linear-gradient(90deg, #795B5B 0%, #9D8074 16.95%, #E7D6CA 100%)",
            text_Button_Primary: "#10030C",
            background_Primary: "#10030C",
            primary: "#C4B2A9",
            text_disabled: "#02060C4D",
        },
        dark: {
            ...BaseTheme.colors.dark,
            background_Button_Primary: "linear-gradient(90deg, #795B5B 0%, #9D8074 16.95%, #E7D6CA 100%)",
            text_Button_Primary: "#10030C",
            background_Primary: "#10030C",
            primary: "#C4B2A9",
            text_disabled: "#02060C4D",
        },
    },
};
